import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { WebActivityLinkedService } from './web-activity.linkedservice';

@Metamodel.model({
    name: 'PowerBIDatasets',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.PowerBI),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.PowerBI)
    ]
})

export class PowerBILinkedService extends WebActivityLinkedService {}
